export default "__VITE_ASSET__9OsqTIim__"